/* import __COLOCATED_TEMPLATE__ from './projected-conversations-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import Component from '@glimmer/component';
import { ProjectedConversationsRanking } from 'embercom/lib/suggestions/constants';

interface Args {
  projectedConversationsCount: number;
  projectedConversationsRanking: ProjectedConversationsRanking;
}

export default class ProjectedConversationsStamp extends Component<Args> {
  get projectedConversationsCount() {
    return this.args.projectedConversationsCount || 0;
  }

  get projectedConversationsRanking() {
    return this.args.projectedConversationsRanking || ProjectedConversationsRanking.Low;
  }

  get rankingStyling() {
    switch (this.projectedConversationsRanking) {
      case ProjectedConversationsRanking.High:
        return 'bg-vis-mantis-40 text-on-success';
      case ProjectedConversationsRanking.Medium:
        return 'bg-vis-mantis-70 text-default';
      case ProjectedConversationsRanking.Low:
        return 'bg-vis-mantis-80 text-default';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::ProjectedConversationsStamp': typeof ProjectedConversationsStamp;
  }
}
